import { UPLOAD_SOURCES } from "@cld/upload-widget";
import { asAbsolute } from "./utils";

type NavItem = { id: string, path: string, title: string };

const navItems: NavItem[] = [{
	id: UPLOAD_SOURCES.LOCAL,
	path: asAbsolute(UPLOAD_SOURCES.LOCAL),
	title: "menu.files",
}, {
	id: UPLOAD_SOURCES.URL,
	path: asAbsolute(UPLOAD_SOURCES.URL),
	title: "menu.web",
}, {
	id: UPLOAD_SOURCES.CAMERA,
	path: asAbsolute(UPLOAD_SOURCES.CAMERA),
	title: "menu.camera",
}, {
	id: UPLOAD_SOURCES.IMAGE_SEARCH,
	path: asAbsolute(UPLOAD_SOURCES.IMAGE_SEARCH),
	title: "menu.gsearch",
}, {
	id: UPLOAD_SOURCES.GOOGLE_DRIVE,
	path: asAbsolute(UPLOAD_SOURCES.GOOGLE_DRIVE),
	title: "menu.gdrive",
}, {
	id: UPLOAD_SOURCES.DROPBOX,
	path: asAbsolute(UPLOAD_SOURCES.DROPBOX),
	title: "menu.dropbox",
}, {
	id: UPLOAD_SOURCES.FACEBOOK,
	path: asAbsolute(UPLOAD_SOURCES.FACEBOOK),
	title: "menu.facebook",
}, {
	id: UPLOAD_SOURCES.INSTAGRAM,
	path: asAbsolute(UPLOAD_SOURCES.INSTAGRAM),
	title: "menu.instagram",
}, {
	id: UPLOAD_SOURCES.SHUTTERSTOCK,
	path: asAbsolute(UPLOAD_SOURCES.SHUTTERSTOCK),
	title: "menu.shutterstock",
}, {
	id: UPLOAD_SOURCES.GETTY,
	path: asAbsolute(UPLOAD_SOURCES.GETTY),
	title: "menu.getty",
},{
	id: UPLOAD_SOURCES.ISTOCK,
	path: asAbsolute(UPLOAD_SOURCES.ISTOCK),
	title: "menu.istock",
}, {
	id: UPLOAD_SOURCES.UNSPLASH,
	path: asAbsolute(UPLOAD_SOURCES.UNSPLASH),
	title: "menu.unsplash",
}];

export default navItems;
